export default __webpack_public_path__ + "static/media/Oxford-Navy.8a119756.jpg";